module.exports = __webpack_public_path__ + "img/home_luntan_icon.ab4c431e.png";